module.exports = __webpack_public_path__ + "static/img/tb-chef-hat.be6244be.svg";